import { FadeUp } from "./Reveal";
import { Landmark, PlayCircle } from "lucide-react";

const PASTOR_YT_ID = "Sryf-4EdeOc";
const FB_REEL_SRC =
  "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F2058186072240663%2F&show_text=false&width=560&t=0";

export const PastorVideo = () => {
  return (
    <section className="relative py-16 sm:py-24 border-y border-border-soft bg-sand-2">
      <div className="max-w-6xl mx-auto px-6 sm:px-8" data-testid="pastor-video-section">
        <FadeUp>
          <div className="text-center">
            <div className="inline-flex items-center gap-2 text-terracotta">
              <Landmark className="h-4 w-4" />
              <span className="text-xs font-semibold uppercase tracking-[0.2em]">
                From Venezuela
              </span>
            </div>
            <h3 className="mt-3 font-serif text-3xl sm:text-4xl tracking-tight text-ink">
              Straight from those on the ground
            </h3>
          </div>
        </FadeUp>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <FadeUp delay={0.1}>
            <div className="relative aspect-video w-full overflow-hidden border border-border-soft bg-ink">
              <iframe
                data-testid="pastor-video"
                src={`https://www.youtube.com/embed/${PASTOR_YT_ID}?rel=0`}
                title="A message from Pastor Ángel Aner González"
                className="absolute inset-0 h-full w-full"
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>
            <div className="mt-4">
              <div className="text-xs uppercase tracking-[0.18em] text-terracotta">
                A message from the pastor
              </div>
              <div className="mt-1 font-serif text-xl text-ink">
                Pastor Ángel Aner González
              </div>
              <div className="mt-1 text-sm text-ink/50">
                Iglesia Cristiana Ríos de Agua Viva · Venezuela
              </div>
            </div>
          </FadeUp>

          <FadeUp delay={0.2}>
            <div className="relative aspect-video w-full overflow-hidden border border-border-soft bg-ink">
              <iframe
                data-testid="situation-update-video"
                src={FB_REEL_SRC}
                title="Update from Venezuela"
                className="absolute inset-0 h-full w-full"
                loading="lazy"
                scrolling="no"
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>
            <div className="mt-4">
              <div className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] text-terracotta">
                <PlayCircle className="h-3.5 w-3.5" /> Situation update
              </div>
              <div className="mt-1 font-serif text-xl text-ink">
                From the ground in Venezuela
              </div>
              <div className="mt-1 text-sm text-ink/50">
                Shared by the church&apos;s local team
              </div>
            </div>
          </FadeUp>
        </div>

        <FadeUp delay={0.3}>
          <div className="mt-14 pt-10 border-t border-border-soft">
            <div className="grid grid-cols-1 md:grid-cols-[auto_1fr] gap-8 md:gap-12 items-start">
              <div className="mx-auto md:mx-0 w-full max-w-[340px]">
                <div className="relative aspect-[9/16] w-full overflow-hidden border border-border-soft bg-ink">
                  <iframe
                    data-testid="ig-reel-video"
                    src="https://www.instagram.com/reel/DbD9nyRRE6S/embed"
                    title="Coverage by Diego Vicentini"
                    className="absolute inset-0 h-full w-full"
                    loading="lazy"
                    scrolling="no"
                    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                    allowFullScreen
                  />
                </div>
              </div>

              <div className="md:pt-6">
                <div className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] text-terracotta">
                  Independent coverage
                </div>
                <h4 className="mt-2 font-serif text-2xl sm:text-3xl leading-snug text-ink">
                  A filmmaker&apos;s report from Venezuela
                </h4>
                <p className="mt-3 max-w-lg text-sm leading-relaxed text-ink/60">
                  Reporting on the ground from Venezuelan filmmaker Diego Vicentini, a first-hand look at how the earthquakes have hit local
                  communities, shared to help raise awareness.
                </p>
                <a
                  href="https://www.instagram.com/reel/DbD9nyRRE6S/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-4 inline-flex items-center gap-2 text-sm text-terracotta hover:underline"
                >
                  @indiegocinema on Instagram &rarr;
                </a>
              </div>
            </div>
          </div>
        </FadeUp>
      </div>
    </section>
  );
};

export default PastorVideo;
